import { UserNewsletterOptionInterface } from '../../interfaces/UserNewsletterOptionInterface'
import axios from '../../utils/axios'
import DateHelper from '../../utils/date'

interface SignUpObject extends GuestObject {
  birthday: string
  plainPassword: string
  newPassword: string | object
}

interface GuestObject {
  firstName: string
  lastName: string
  email: string
  tos: boolean
  newsletter: boolean
  newsletterOptions?: UserNewsletterOptionInterface[]
}

export function signUp(formData: SignUpObject) {
  const bDate = DateHelper.dateToUnixTimestamp(formData.birthday.toString(), true)
  formData.birthday = bDate === false ? '' : bDate.toString()
  formData.newPassword = { second: formData.plainPassword, first: formData.newPassword }
  return axios({
    method: 'POST',
    url: '/profile.json',
    data: formData,
  })
}

export function createGuest(formData: GuestObject) {
  return axios({
    method: 'POST',
    url: '/profile/guest.json',
    data: formData,
  })
}

export function signIn(email: string, password: string) {
  return axios({
    method: 'POST',
    url: '/security/login',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    data: {
      username: email,
      password,
    },
  })
}
//TODO: remove?
export function setCookie(tokenId: string, secret: string) {
  return axios({
    method: 'GET',
    url: `/security/set-cookie/${tokenId}/${secret}/1`,
  })
}
//TODO: remove?
export function destroyCookie() {
  return axios({
    method: 'GET',
    url: '/security/destroy-cookie',
  })
}

export function logOut() {
  return axios({
    method: 'GET',
    url: '/security/logout',
  })
}

export function isAuth() {
  return axios({
    method: 'GET',
    url: '/security/is-auth',
  })
}

export function facebookAuth() {
  return axios({
    method: 'POST',
    url: '/security/login/facebook.json',
  })
}
